// Depends
import { route, meta } from '@/helpers/routes'
import DwellerRegister from './dweller/form'

export default [
  route('dweller', '/dweller', DwellerRegister, meta('Cadastro de novos Moradores', false, 'guest', true))
]



// WEBPACK FOOTER //
// ./src/app/auth/register/routes.js